<app-modal-header (closeModal)="close()"></app-modal-header>
@defer (when vcard) {
  <app-modal-body>
    <div class="row">
      <div class="col-12">
        <div class="text-center">
          <img
            [src]="loader?.attendee_img"
            [alt]="loader?.attendee_name"
            class="rounded-circle object-fit-cover img-avatar"
            [appImgErrorFallback]="defaultUserImg"
            width="60px"
            height="60px"
            loading="lazy"
          />
          <p class="fw-medium mt-2">{{ loader?.attendee_name }}</p>
          <hr />
        </div>

        <div [formGroup]="form" class="form">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="isHasEmail" formControlName="isHasEmail" />
            <label class="form-check-label" for="isHasEmail"> {{ 'EMAIL' | translate }} </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="isHasPhone" formControlName="isHasPhone" />
            <label class="form-check-label" for="isHasPhone"> {{ 'PHONE' | translate }} </label>
          </div>
          @if (isEdit) {
            <div class="row">
              <div class="col-4 mt-3">
                <label for="cc" class="form-label">{{ 'COUNTRY_CODE' | translate }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="cc"
                  placeholder="your country code"
                  formControlName="countryCode"
                />
              </div>
              <div class="col-8 mt-3">
                <label for="mobile" class="form-label">{{ 'MOBILE' | translate }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="mobile"
                  placeholder="your mobile"
                  formControlName="mobile"
                />
              </div>
            </div>
          }

          @if (!isEdit) {
            <div class="d-flex flex-wrap">
              <div>
                <p class="mb-0 p-2">+{{ vcard?.cc }}-{{ vcard?.mobile }}</p>
              </div>
              <div>
                <button type="button" class="btn p-2 bg-color-contrast" (click)="showFormEdit()">
                  <i class="ri-pencil-fill"></i>
                  {{ 'EDIT' | translate }}
                </button>
              </div>
            </div>
          }

          @if (
            (countryCodeControl.touched && countryCodeControl.errors?.['required']) ||
            (mobileControl.touched && mobileControl.errors?.['required']) ||
            (form.touched && form.invalid)
          ) {
            <p class="mb-0 text-danger fs-13px mt-2">
              {{ 'ENTER_YOUR_NUMBER_IN_FORMAT' | translate }}
              <span class="fw-medium">[{{ 'COUNTRY_CODE' | translate }}]</span> -
              <span class="fw-medium">[{{ 'MOBILE_NUMBER' | translate }}]</span>
            </p>
          }
        </div>
      </div>
    </div>
  </app-modal-body>
  <app-modal-footer classList="d-flex justify-content-center">
    <button type="button" class="btn btn-primary rounded-5" (click)="sendNameCard()" [disabled]="isHttpRequestRunning">
      @if (isHttpRequestRunning && activeButton === ActiveButton.SEND_NAMECARD) {
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      }
      {{ 'SEND_NAMECARD' | translate }}
    </button>
  </app-modal-footer>
} @placeholder {
  @if (isShowPlaceholder) {
    <app-modal-body>
      <app-skeleton-general-list [count]="4" />
    </app-modal-body>
  }
}
